export default __webpack_public_path__ + "static/location-new-york-e83428670300ad6011aaa0656866d478.png";